import React from "react";
import "../styles.scss";
import TestsID from "../../../utils/TestsID";
import KC_Button, {
  KC_ButtonType
} from "../../../designsystem/KC_Button/KC_Button";
import { SaasFlyersOrderActionContainerI } from "../../../model/saasFlyersOrderActionContainerI";

export const SaasFlyersOrderActionWrapper = ({
  actionsLabel = [],
  handlePrev,
  handleNext,
  nextDisabled,
  prevDisabled,
  extraProps
}: SaasFlyersOrderActionContainerI) => {
  if (actionsLabel?.length < 2) return null;
  return (
    <div className="saas-flyers-order__actions-container">
      {/* Forces the other elements to be on the right of the grid (similar to flex-end) */}
      <div id="dummy" />
      <KC_Button
        type={KC_ButtonType.Submit}
        id={TestsID.SAAS_FLYERS_ORDER_PREV_BUTTON}
        disabled={prevDisabled}
        onClick={handlePrev}
        text={actionsLabel[0]}
        isInverted={true}
        className="d-flex"
      />
      <KC_Button
        id={TestsID.SAAS_FLYERS_ORDER_NEXT_BUTTON}
        disabled={nextDisabled}
        // isSecondary={true}
        onClick={(e: React.SyntheticEvent) => {
          handleNext(e, extraProps);
        }}
        text={actionsLabel[1]}
        className="d-flex"
      />
    </div>
  );
};

export default SaasFlyersOrderActionWrapper;
